import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';

export default class SupplierAIModelService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  getTfidfPreferences(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_tfidf_preferences + '?' + querystring, {});
  }

  deleteTfidfPreference(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.delete(api.delete_tfidf_preference + '?' + querystring, {});
  }
}
